<template>

    <!--seccion top-->
    <div class="row mt-2">
        <div class="col-md-2">
          <a target="_self" href="https://houseandflats.com/">                  
              <img style="width:80%" class="img-fluid" src="../assets/logo.png" >
          </a>
        </div>
        <div class="col-md-4 mt-5">      
          <div class="col-lg-6 col-md-12">
              <div class="content-select">
                  <select @change="setMoneda(moneda), getAlojamientos()" v-model="moneda" class="btn-custom ind-0">
                        <option value="" selected >$ CLP</option>
                        <option v-bind:value="moneda.cambio" :key="moneda.idtipo_cambio" v-for="moneda in tipocambio" class="black">
                            <div v-if="moneda.moneda === 'en_US'">$ USD</div>
                            <div v-else-if="moneda.moneda === 'en_GB'">£ GBP</div>
                            <div v-else-if="moneda.moneda === 'it_IT'">€ EUR</div>
                            <div v-else-if="moneda.moneda === 'es_AR'">$ ARS</div>
                        </option>
                  </select>
                  <i></i>
              </div>
          </div>          
        </div>
        <div class="col-md-6 mt-5">        
            <a href="javascript: void(0);">
            <div @click="cambioIdioma" v-if="iso639_1 === 'es'" class="float-right">
                <span class="rounded-circle"> <img  class="mt-6 mlc-5"  src="../assets/united-kingdom.png"></span> 
            </div>  
            <div @click="cambioIdioma" v-else class="float-right">
                <span class="rounded-circle"> <img  class="mt-6 mlc-5"  src="../assets/espania.png"></span>
            </div>  
            </a>            
        </div>
    </div>
    <!--fin seccion top-->
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: 'ControlsHeader',
  data(){
      return{
        moneda: ''
      }
  },
  methods:{
    ...mapActions(['getPais', 'cambioIdioma', 'getTipoCambio', 'setMoneda', 'getAlojamientos'])
  },
  computed:{
    ...mapState(['language', 'iso639_1', 'pais', 'ciudad', 'tipocambio'])
  },  
  mounted () {
    this.getTipoCambio()
    if(!this.iso639_1){
        this.getPais()  
    }  
     
  }
}
</script>

<style scoped>
span  {
  display: inline-block;
  width: 49px;
  height: 49px;
  background-color: #FFFFFF;
  box-shadow: 1px 2px 6px 1px rgba(0, 0, 0, 0.103);
}
</style>



